import { appInsights } from "./appInsights";

class Logger{ 
    static info(message, properties = {}) { 
        console.log(`[INFO]: ${message}`, properties);
        appInsights.trackTrace({ message: message, severityLevel: 1, properties})
    }

    static warn(message, properties = {}) { 
        console.warn(`[WARN]: ${message}`, properties);
        appInsights.trackTrace({ message: message, severityLevel: 2, properties})
    }

    static error(message, errorObj = null, properties = {}) { 
        console.error(`[ERROR]: ${message}`, errorObj || "", properties)

        if(errorObj instanceof Error) { 
            appInsights.trackException({ 
                error: errorObj,
                severityLevel: 3,
                properties: { message, ...properties}
            });
        } else { 
            appInsights.trackTrace({ 
                message: `[ERROR]: ${message}`,
                severityLevel: 3,
                properties: { errorDetails: errorObj, ...properties}
            })
        }
    }
}

export default Logger;